import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-button',
  templateUrl: './form-button.component.html',
  styleUrls: ['./form-button.component.scss']
})
export class FormButtonComponent implements OnInit {
  @Input() form: FormGroup
  @Input() label: string = ''
  @Input() disabled: any = false
  @Input() loading: boolean = false

  constructor() { }

  ngOnInit(): void {
  }

}
